/**
 * Asset URL Utility
 *
 * Provides environment-conscious asset URLs.
 * The CDN base URL comes from the single config module (VITE_ASSETS_URL).
 *
 * Environment examples:
 * - Production: https://assets.til.sg
 * - Staging: https://stg-assets.til.sg
 * - Development: https://stg-assets.til.sg (or local)
 */

import { ASSETS_BASE_URL } from '@/lib/config/api.config';

/**
 * Get the full URL for an asset path
 * @param path - The asset path (should start with /)
 * @returns Full URL to the asset
 */
export function getAssetUrl(path: string): string {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${ASSETS_BASE_URL}${normalizedPath}`;
}

/**
 * Get the assets base URL (useful for dns-prefetch, etc.)
 */
export function getAssetsBaseUrl(): string {
  return ASSETS_BASE_URL;
}

/**
 * Placeholder image paths for common use cases
 */
export const ASSET_PATHS = {
  // Homepage
  SINGAPORE_BACKDROP: '/placeholders/homepage/singapore-backdrop.webp',
  HOME_BANNER: '/placeholders/homepage/home-banner.webp',
  MARKETPLACE_WIP: '/placeholders/homepage/marketplace-wip.webp',

  // User avatars
  USER_AVATAR: (index: number) => `/placeholders/user-avatars/user-placeholder-${index}.webp`,
} as const;
